export const NAVBAR = [
    {
        "link":"/",
        "name":"Anasayfa",
        "isInternal":true
    },
    {
        "link":"https://exchange.gmskripto.com/",
        "name":"Piyasalar",
        "isInternal":false
    },
    {
        "link":"https://exchange.gmskripto.com/protade",
        "name":"Al/Sat",
        "isInternal":false
    },
    {
        "link":"https://exchange.gmskripto.com/easytrade",
        "name":"Kolay Al/Sat",
        "isInternal":false  
    },
    {
        "link":"/kampanya-merkezi",
        "name":"Kampanya Merkezi",
        "isInternal":true
    },
    {
        "link":"/destek-merkezi",
        "name":"Destek Merkezi",
        "isInternal":true
    },
    {
        "link":"https://exchange.gmskripto.com/wallets",
        "name":"Cüzdan",
        "isInternal":false
    }
]
